import React, { useState } from 'react';

import fileDownload from 'react-file-download';

import { Alert, Button, Stack, TextField } from '@mui/material';

import { queueMusementPaidReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';

const ErrorMessage = () => (
  <Alert severity="error">
    <strong>Oops!</strong>
    <p>An error occurred while downloading.</p>
  </Alert>
);

export type ExportStatus = 'not-started' | 'completed' | 'failed' | 'pending';

const ExportMusementPaidForm = () => {
  const [exportStatus, setExportStatus] = useState<ExportStatus>('not-started');
  const [startAt, setStartAt] = useState(formatDateISO(startOfMonth(subMonths(1))));
  const [endAt, setEndAt] = useState(formatDateISO(startOfMonth()));

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setExportStatus('pending');

    try {
      const text = await queueMusementPaidReport({ startAt, endAt });
      const fileName = `musement-payments-between-${startAt}-and-${endAt}.csv`;
      fileDownload(text, fileName);
      setExportStatus('completed');
    } catch {
      setExportStatus('failed');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {exportStatus === 'failed' && <ErrorMessage />}

      <Stack direction="column" spacing={2} sx={{ maxWidth: 400 }}>
        <TextField
          label="Select Start Date"
          type="date"
          value={startAt}
          onChange={(e) => setStartAt(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Select End Date"
          type="date"
          value={endAt}
          onChange={(e) => setEndAt(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        <div>
          <Button type="submit" variant="contained" disabled={exportStatus === 'pending'}>
            {exportStatus !== 'pending' ? 'Download Report' : 'Downloading...'}
          </Button>
        </div>
      </Stack>
    </form>
  );
};

export default ExportMusementPaidForm;
